var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-shell app-shell--desktop" },
    [
      !_vm.shouldHideHeader
        ? _c("AppHeader", {
            on: {
              "blur-wrapper": function($event) {
                _vm.blurred = !_vm.blurred
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Banner"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-body", class: { blurred: _vm.blurred } },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.hideFooter ? _c("AppFooter") : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowSignupModal ? _c("SignupModal") : _vm._e(),
      _vm._v(" "),
      _vm.user.is_authenticated && !_vm.privacyProperties.viewed_privacy_banner
        ? _c("PrivacyBanner")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }